import { render, staticRenderFns } from "./PromoActionBtn.vue?vue&type=template&id=61e3c78d&"
import script from "./PromoActionBtn.vue?vue&type=script&lang=js&"
export * from "./PromoActionBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports